import React from 'react';
import { Box } from '@mui/material';
import AgentFilesTable from '../AgentFilesTable';
import PanelCard from './PanelCard';

function DocumentsPanel() {
  return (
    <Box>
      <PanelCard title="Dokumente" subtitle="Hochgeladene Dateien des Beraters">
        <AgentFilesTable />
      </PanelCard>
    </Box>
  );
}

export default DocumentsPanel;
